<template>
<div>
  <body>
    <div class="voucher" >
      <h1 class="read-only">SAVE THE TREES 교환권 페이지</h1>
      <section class="header">
        <div class="element">
          <p><span class="read-only">SAVE THE TREES</span></p>
          <span><span class="read-only">나무 이미지</span></span>
        </div>
        <div class="item">
          <div>
            <div>
              <h2><span>{{ couponInfo.coupon_name }}</span></h2>
              <p>{{ couponInfo.coupon_type }}</p>
            </div>
          </div>
          <div>
            <img :src="couponInfo.product_image" class="product" alt="제품">
            <p v-html="getProductNameForEnter(couponInfo.product_name)"></p>
          </div>
        </div>
      </section>
      <coupondetailvue 
        :propCouponInfo="this.propCouponInfo"
        :propCouponDetail="this.propCouponDetail"
        :aboInfo="this.aboInfo"
        :couponNo="this.couponNo"
      />
    </div>
  </body>
</div>
</template>
<script>

// Library
import coupondetailvue from './component/coupondetail.vue'
export default {
    metaInfo: {
    title: 'SAVE THE TREES 교환권 페이지',
    meta: [
        { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { charset:'utf-8' },
        { name:'viewport', content:'width=device-width, initial-scale=1' },
        { name:'keywords'},
        { name:'description', content:'SAVE THE TREES'},
        { name:'robots', content:'index,follow'},
        { property:'og:description', content:'ESG 공존의 실천 SAVE THE TREES 캠페인 당첨 안내'},
        { property:'og:image', content:'./assets/images/kakao_thumb.jpg'}
    ]
    },
    name: 'savethetrees',
    components:{
      coupondetailvue
    },
    props:{
      propCouponInfo: {},
		  propCouponDetail: [],
      aboInfo: {},
      couponNo: ''
    },
    data () {
      return {
        couponInfo: {},
      }
    },
    methods: {
      init: async function () { // 초기화
        this.couponInfo=this.propCouponInfo
      },
      getProductNameForEnter: function(pName){
          if(pName){
              return pName.replace(/(?:\r\n|\r|\n)/g, '<br />');
          }
          return pName
      },
    },
    mounted() {
      window.setTimeout(() => {
        this.ready = true
        this.init()
        }, 50)
    },    
}
</script>

<style scoped>
    @import './assets/style.css';
</style>



// WEBPACK FOOTER //
// src/views/couponsys/savethetrees.vue